import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { duotone } from '@fortawesome/fontawesome-svg-core/import.macro';
import { useTranslation } from 'react-i18next';
import useMonitorAPIService from 'src/services/monitorapiservice';
import { connect } from 'react-redux';

function GroupStatusModal(props) {

    const { t } = useTranslation();
    const { changeGroupStatus } = useMonitorAPIService();

    const send = e => {
        let data = {
            group: props.selected.groupId,
            closed: !props.selected.opened,
            automatic: !props.selected.automatic
        }
        if (props.type === "mode") {
            data = {
                group: props.selected.groupId,
                closed: false,
                automatic: !props.selected.automatic
            }
        }

        if (props.type === "state") {
            data = {
                group: props.selected.groupId,
                closed: props.selected.opened,
                automatic: false
            }
        }
        
        changeGroupStatus(props.token, data, res => {
            if (!res.data) {
            } else {
            }
            props.toggleModal();
        });

    }
    return (
        <Modal
            size="md"
            show={props.show}
            onHide={props.toggleModal}
            aria-labelledby="">
            <Modal.Header closeButton>
                <Modal.Title id="">{t("changegroupstatus")}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>
                    {t("abouttochangegroupstatus")}
                    {
                        props.type === "mode" &&
                        <span>{props.selected.automatic ? t("manual") : t("automatic").toLowerCase()}</span>
                    }

                    {
                        props.type === "state" &&
                        <span>{props.selected.opened ? t("closed").toLowerCase() : t("open").toLowerCase()}</span>
                    }
                </p>
                <p>{t("areyousure")}</p>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="primary" onClick={send}>
                    <FontAwesomeIcon icon={duotone("paper-plane-top")} /> {t("send")}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}


const mapStateToProps = (state) => {
    return {
        token: state.supervisor.token,
    };
};

export default connect(mapStateToProps, {})(GroupStatusModal);